import { openBlock as n, createElementBlock as o, normalizeClass as s, normalizeStyle as u, renderSlot as a } from "vue";
import { _ as c } from "../_plugin-vue_export-helper-dad06003.js";
const f = {
  name: "rCol",
  props: {
    /**
     * 栅格的占位格数，可选值为0~24的整数，为 0 时，相当于display:none
     */
    span: {
      type: [Number, String],
      default: 0
    },
    /**
     * 栅格的顺序
     */
    order: {
      type: String,
      default: ""
    },
    /**
     * 栅格左侧的间隔格数，间隔内不可以有栅格
     */
    offset: {
      type: [Number, String],
      default: ""
    },
    /**
     * 栅格向右移动格数
     */
    push: {
      type: [Number, String],
      default: ""
    },
    /**
     * 栅格向左移动格数
     */
    pull: {
      type: [Number, String],
      default: ""
    }
  },
  computed: {
    gutter() {
      let e = this.$parent;
      for (; e && e.$options.name !== "rRow"; )
        e = e.$parent;
      return e ? e.gutter : 0;
    },
    styles() {
      const e = {};
      return this.gutter > 0 && (e.paddingLeft = `${this.gutter / 2}px`, e.paddingRight = e.paddingLeft), e;
    }
  }
};
function i(e, d, t, m, p, l) {
  return n(), o(
    "div",
    {
      class: s(["r-col", {
        [`r-col-${t.span}`]: !0,
        [`r-col-offset-${t.offset}`]: t.offset,
        [`r-col-pull-${t.pull}`]: t.pull,
        [`r-col-push-${t.push}`]: t.push,
        [`r-col-order-${t.order}`]: t.order
      }]),
      style: u(l.styles)
    },
    [
      a(e.$slots, "default")
    ],
    6
    /* CLASS, STYLE */
  );
}
const r = /* @__PURE__ */ c(f, [["render", i], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/col/col.vue"]]);
r.install = function(e) {
  e.component(r.name, r);
};
export {
  r as default
};
